module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ls-title-intro ls-no-padding-top ls-sm-margin-bottom ls-display-flex align-items-center flex-wrap"
  }, [_c('div', {
    staticClass: "col-lg-6 col-xs-12"
  }, [_c('h1', {
    class: 'ls-no-margin-bottom ls-no-padding ls-title-intro breadcrumb-title ' + _vm.crumbs.ico
  }, [_c('div', {
    staticClass: "breadcrumb-content"
  }, [_c('ol', {
    staticClass: "ls-breadcrumb"
  }, [_c('li', [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Início")])], 1), _vm._v(" "), _vm._l((_vm.crumbs.paths), function(crumb) {
    return _c('li', [(crumb.path) ? _c('router-link', {
      staticClass: "link",
      attrs: {
        "to": {
          path: crumb.path
        }
      }
    }, [_vm._v(_vm._s(crumb.title))]) : _c('span', [_vm._v(_vm._s(crumb.title))])], 1)
  })], 2), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.crumbs.section))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-xs-12 ls-sm-margin-top"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1266cfa6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/shareds/Breadcrumb.vue
// module id = 728
// module chunks = 1